import { Notifications } from '@intigral/shared';
import { Outlet } from 'react-router-dom';
import RefreshTokenErrorDialog from '../components/RefreshTokenErrorDialog';
import { RouteCondition, RouteGuard } from './guard';

const BlankLayout = ({ conditions, context }: { conditions: RouteCondition[]; context: any }) => {
    return (
        <RouteGuard conditions={conditions} context={context}>
            <Outlet />
            <RefreshTokenErrorDialog />
            <Notifications />
        </RouteGuard>
    );
};

export default BlankLayout;
